import React, { useEffect, useState } from "react";
import Header from "../../Components/Header/Header";
import Footer from "../../Components/Footer/Footer";
import { FaRegUserCircle } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { LuMessageSquareMore } from "react-icons/lu";
import { FaBuilding } from "react-icons/fa";
import { APIUrl, APIUrlToken } from "../../Utils/Utils";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FiPhone } from "react-icons/fi";
import { MdSubject } from "react-icons/md";

const Contactus = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    email: "",
    phone_number: "",
    company_name: "",
    subject: "",
    message: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

  const handleSubmit = async () => {
    const {
      first_name,
      last_name,
      email,
      phone_number,
      company_name,
      subject,
      message,
    } = formData;

    if (!first_name.trim()) {
      toast.error("Please enter your First Name.");
      return;
    }

    if (!last_name.trim()) {
      toast.error("Please enter your Last Name.");
      return;
    }

    if (!email.trim()) {
      toast.error("Please enter your Email Address.");
      return;
    }

    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid Email address.");
      return;
    }

    if (!phone_number.trim()) {
      toast.error("Please enter your Phone Number.");
      return;
    }

    if (!subject.trim()) {
      toast.error("Please enter a Subject.");
      return;
    }

    if (!message.trim()) {
      toast.error("Please enter your Message.");
      return;
    }

    const url = `${APIUrl()}/v1/contact_us`;
    const options = {
      method: "POST",
      headers: {
        "X-API-Key": APIUrlToken(),
      },
      data: {
        first_name,
        last_name,
        email,
        phone_number,
        company_name,
        subject,
        message,
      },
      url: url,
    };

    try {
      setLoading(true);
      const response = await axios(options);
      setFormData({
        first_name: "",
        last_name: "",
        email: "",
        phone_number: "",
        company_name: "",
        subject: "",
        message: "",
      });
      toast.success("Your query has been submitted successfully");
      navigate("/");
    } catch (error) {
      toast.error("Error occurred while saving your data. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Header />
      <div className="page-main-container-aboutus">
        <div className="content-section-changepass">
          <h3>Contact Us</h3>
          <div
            style={{
              width: "100%",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="input-section-changepass cu-nil">
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div>
                <input
                  type="text"
                  name="first_name"
                  placeholder="First Name"
                  className="form-control-changepass-user"
                  value={formData.first_name}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil">
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaRegUserCircle />
                </div>
                <input
                  type="text"
                  name="last_name"
                  placeholder="Last Name"
                  className="form-control-changepass-user"
                  value={formData.last_name}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil">
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FaBuilding />
                </div>
                <input
                  type="text"
                  name="company_name"
                  placeholder="Company Name (If Applicable)"
                  className="form-control-changepass-user"
                  value={formData.company_name}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="input-section-changepass cu-nil">
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <MdEmail />
                </div>
                <input
                  type="email"
                  name="email"
                  placeholder="Email Address"
                  className="form-control-changepass-user"
                  value={formData.email}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil">
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <FiPhone />
                </div>
                <input
                  type="text"
                  name="phone_number"
                  placeholder="Phone Number"
                  className="form-control-changepass-user"
                  value={formData.phone_number}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil">
              <div className="input-group-changepass">
                <div className="input-icon-changepass">
                  <MdSubject />
                </div>
                <input
                  type="text"
                  name="subject"
                  placeholder="Subject"
                  className="form-control-changepass-user"
                  value={formData.subject}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>

            <div className="input-section-changepass cu-nil">
              <div className="input-group-changepass">
                <div className="input-icon-changepass-contact">
                  <LuMessageSquareMore />
                </div>
                <textarea
                  name="message"
                  placeholder="Message"
                  className="form-control-changepass-user"
                  value={formData.message}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
            </div>
            <div className="input-section-changepass cu-nil"></div>

            <div className="button-section-changepass-user">
              <button onClick={handleSubmit} disabled={loading}>
                {loading ? "Submitting..." : "Submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default Contactus;
